import { Button } from "primereact/button";

import "./style.scss";

const ButtonUi = ({ id = "", label = "", onClick = () => {}, className = "", icon = null, disabled = false, iconPos = "right", type = "", loaderBtn }) => (
    <Button
        id={id}
        label={loaderBtn ? "" : label}
        onClick={onClick}
        className={`button-ui ${className} ${type}`}
        icon={icon}
        disabled={disabled}
        iconPos={iconPos}
        loading={loaderBtn}
        loadingIcon={
            <div className="loader__btn" id="loader-4">
                <span></span>
                <span></span>
                <span></span>
            </div>
        }
    />
);

export default ButtonUi;
